export const translation_14_1_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `두 번째 훈련법`,
      typography_1: `우린 현재 RAIN 중 인지하기(R, Recognition)를 훈련하고 있습니다. 인지하기를 훈련하는 방법에는 두 가지가 있다고 했습니다. 첫째는 기록을 통해 연습하는 '경험 분리'이고, 둘째는 명상을 통해 연습하는 '주의 통제'입니다. 이 두 번째 방법을 지금부터 배워나갈 것입니다.`,

      typography_2: `마음의 동굴 탐험`,
      typography_3: `내 마음을 다스리는 건 캄캄한 동굴 속에서 길을 찾는 과정과 비슷합니다. 어둡고 무서운 동굴에서는 때때로 부정적인 생각과 감정이 불쑥 튀어나오곤 하죠. 겁이 나면 우리는 나도 모르게 손에 든 손전등을 여기저기 마구 휘두르게 됩니다.`,
      typography_4: `하지만 불안해서 불빛을 흔들수록 오히려 길을 잃기 쉽습니다. 동굴 속에서 안전하게 앞으로 나아가려면, 가장 먼저 내 손에 든 손전등부터 원하는 대로 조절할 수 있어야 합니다. 마음속 동굴에는 생각보다 밝고 따뜻한 것들이 훨씬 많이 숨어 있으니 너무 걱정하지 않으셔도 좋습니다.`,

      typography_5: `마음의 작업 공간`,
      typography_6: `뇌과학과 심리학에서는 우리 마음을 뇌의 '작업 공간'이라고 부릅니다. 이 작업 공간은 크기가 한정되어 있어서 끊임없이 쏟아지는 감각과 기억을 한 번에 다 처리할 수는 없습니다. 수많은 정보 중 어떤 것을 작업대 위에 올릴지 결정하는 지휘자가 필요한데, 이 지휘자가 바로 '주의력'입니다.`,
      typography_7: `주의력은 우리 마음의 손전등을 세 가지 방식으로 섬세하게 조절합니다. 첫째는 수많은 자극 중 필요한 것만 골라내는 '선택하는 주의'이고, 둘째는 방해를 이겨내고 한 곳에 빛을 계속 비추는 '지속하는 주의'입니다. 마지막 셋째는 상황이 바뀌었을 때 미련 없이 다른 곳으로 불빛을 옮기는 '전환하는 주의'입니다.`,
      typography_8: `다음 중 세 가지 주의력 중 하나인 '전환하는 주의'가 가장 잘 발휘된 상황은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_9: `정답은 B입니다. A는 하나의 자극만 걸러내는 '선택적 주의', C는 오랫동안 집중을 유지하는 '지속적 주의'입니다. B처럼 이전의 목표(독서)를 내려놓고 새로운 정보(통화)로 손전등의 방향을 빠르게 옮기는 것이 바로 '전환하는 주의'입니다.`,

      typography_10: `간단한 체험`,
      typography_11: `이제 이 세 가지 주의력을 직접 써볼 수 있는 간단한 소리 명상을 해보겠습니다. 먼저 주변에서 들려오는 특정한 소리 하나를 알아차려보세요. 자동차 지나가는 소리도 좋고 에어컨 소리도 좋습니다. 눈을 감고 알아차린 뒤 다시 눈을 떠보세요.`,
      typography_12: `좋습니다. 이것이 '선택하는 주의'입니다.`,
      typography_13: `이번엔 다시 눈을 감고 아까 들려왔던 그 소리에 약 10초 동안 가만히 집중해보겠습니다. 세상에서 그 소리가 가장 중요한 것처럼 귀 기울여 보세요. 진행해보신 뒤 다음으로 넘어가주세요.`,
      typography_14: `잘하셨습니다. 이것이 '지속하는 주의'입니다.`,
      typography_15: `마지막으로 아까 그 소리에 주의를 두다가 다른 소리에 주의를 옮겨봅니다. 시계 초침 소리에 3초, 냉장고 소리에 3초, 바깥의 새소리에 3초, 이런 식으로요. 눈을 감고 시작해보세요.`,
      typography_16: `이것은 '전환하는 주의'입니다. 손전등의 방향을 이리저리 빠르게 옮기는 힘이죠.`,

      typography_17: `주의력 근육 키우기`,
      typography_18: `내가 원하는 곳에 손전등을 비추는 일은 처음엔 생각처럼 잘되지 않습니다. 명상이나 일상생활 중에 자꾸만 주의를 빼앗기고 딴생각에 빠지는 건 우리 뇌 구조상 지극히 자연스러운 일입니다. 그러니 집중이 깨졌다고 실망할 필요 없습니다. 그저 '아, 딴생각을 했네' 하고 알아차린 뒤 묵묵히 다시 불빛을 제자리로 돌려놓으면 그만이니까요.`,
      typography_19: `이렇게 주의를 제자리로 돌려놓는 과정 자체가 바로 집중력 근육을 탄탄하게 키워주는 핵심 운동입니다. 이 기초 체력이 길러지면 부정적인 감정에 휩쓸리지 않고, 배운 디스턴싱 기술들을 실행할 수 있게 될 것입니다.`,
      typography_20: `앞으로 네 번에 걸쳐 본격적인 명상 훈련을 하며 이 튼튼한 근육을 함께 만들어 보겠습니다. 하루에 단 몇 분이라도 좋으니, 오늘 배운 '손전등'을 기억하며 일상에서 내 주의력의 방향을 스스로 선택해 보세요.`,
      typography_21: `명상 훈련 중 갑자기 '오늘 저녁에 뭐 먹지?'라는 잡념이 떠올랐습니다. 가장 올바른 대처 방법은 무엇일까요?`,
      typography_22: `정답은 B입니다. 주의를 빼앗기는 건 뇌의 아주 자연스러운 반응입니다. 잡념과 싸우거나 끌려가지 않고 부드럽게 주의를 되돌리는 그 과정에서 '주의 집중 근육'이 단단해집니다.`,
      typography_23: `지금까지 마음의 동굴 속에서 '주의력'이라는 손전등을 어떻게 다루어야 하는지 그 원리를 함께 알아보았습니다. 머리로 이해하는 것을 넘어 실전 근육을 기르기 위해, 앞으로 네 번에 걸쳐 본격적인 명상 훈련을 시작해 보겠습니다.`,
    },
  },
};
